import {
  Package,
  CreditCard,
  Infinity,
  Layers,
  Zap,
  AlignLeft,
  Languages,
  FileText,
  GraduationCap,
  Bot
} from 'lucide-react';
import {
  PlanType,
  PricePlanTierInput,
  ProcessingType
} from '@utils/types/back-office/update-plan-bo';

export interface WizardFormData {
  type: PlanType;
  sku: string;
  description: string;
  processing_type: ProcessingType;

  batch_enabled: boolean;
  realtime_enabled: boolean;
  realtime_max_concurrent_streams?: number | null;
  realtime_languages_csv?: string;
  alignment_enabled: boolean;
  translation_enabled: boolean;
  templates_exported_enabled: boolean;
  automatic_training_enabled: boolean;
  ai_summaries_enabled: boolean;
  ai_summaries_monthly_limit?: number | null;

  stt_pricing_mode: 'existing' | 'inline';
  stt_pricing_plan?: number;
  stt_pricing_plan_name?: string;
  stt_pricing_tiers: PricePlanTierInput[];

  alignment_pricing_mode: 'existing' | 'inline';
  alignment_pricing_plan?: number;
  alignment_pricing_plan_name?: string;
  alignment_pricing_tiers: PricePlanTierInput[];

  stt_limit?: number;
  media_unit_size?: number;

  translation_pricing_mode: 'flat' | 'existing' | 'inline';
  translation_pricing_plan?: number;
  translation_pricing_plan_name?: string;
  translation_pricing_tiers: PricePlanTierInput[];
  translation_cost?: number;
  translation_characters?: number;
  translation_character_limit?: number | null;

  monthly_cost?: number;
  cost?: number;
  minimal_invoice?: number;

  automatic_training_unit_cost?: number;
  automatic_training_monthly_cost?: number;

  stt_templates_exported_cost?: number;

  is_fair_use: boolean;
  fair_use_rate_limit?: number;
  automatic_training_unit_limit?: number;
  automatic_training_hosting_limit?: number;
  custom_model_yearly_limit?: number;

  send_exceedance_email?: boolean;
  exceedance_email_recipients?: string;

  reseller_ids: number[];
}

export const PLAN_TYPE_OPTIONS: {
  type: PlanType;
  icon: typeof Package;
  color: string;
  bgColor: string;
}[] = [
  {
    type: 'Bundle',
    icon: Package,
    color: 'rgba(245, 158, 11, 0.7)',
    bgColor: 'rgba(245, 158, 11, 0.05)'
  },
  {
    type: 'Pay as you Go',
    icon: CreditCard,
    color: 'rgba(99, 102, 241, 0.7)',
    bgColor: 'rgba(99, 102, 241, 0.05)'
  },
  {
    type: 'Perpetual',
    icon: Infinity,
    color: 'rgba(16, 185, 129, 0.7)',
    bgColor: 'rgba(16, 185, 129, 0.05)'
  }
];

export const FEATURE_OPTIONS: {
  key: keyof Pick<
    WizardFormData,
    | 'batch_enabled'
    | 'realtime_enabled'
    | 'alignment_enabled'
    | 'translation_enabled'
    | 'templates_exported_enabled'
    | 'automatic_training_enabled'
    | 'ai_summaries_enabled'
  >;
  label: string;
  description: string;
  icon: typeof Package;
  color: string;
  bgColor: string;
}[] = [
  {
    key: 'batch_enabled',
    label: 'batch-stt',
    description: 'batch-stt-feature-description',
    icon: Layers,
    color: 'rgba(59, 130, 246, 0.7)',
    bgColor: 'rgba(59, 130, 246, 0.05)'
  },
  {
    key: 'realtime_enabled',
    label: 'realtime-stt',
    description: 'realtime-stt-feature-description',
    icon: Zap,
    color: 'rgba(139, 92, 246, 0.7)',
    bgColor: 'rgba(139, 92, 246, 0.05)'
  },
  {
    key: 'alignment_enabled',
    label: 'alignment',
    description: 'alignment-feature-description',
    icon: AlignLeft,
    color: 'rgba(16, 185, 129, 0.7)',
    bgColor: 'rgba(16, 185, 129, 0.05)'
  },
  {
    key: 'translation_enabled',
    label: 'translation',
    description: 'translation-feature-description',
    icon: Languages,
    color: 'rgba(245, 158, 11, 0.7)',
    bgColor: 'rgba(245, 158, 11, 0.05)'
  },
  {
    key: 'templates_exported_enabled',
    label: 'export-templates',
    description: 'export-templates-feature-description',
    icon: FileText,
    color: 'rgba(236, 72, 153, 0.7)',
    bgColor: 'rgba(236, 72, 153, 0.05)'
  },
  {
    key: 'automatic_training_enabled',
    label: 'automatic-training',
    description: 'automatic-training-feature-description',
    icon: GraduationCap,
    color: 'rgba(99, 102, 241, 0.7)',
    bgColor: 'rgba(99, 102, 241, 0.05)'
  },
  {
    key: 'ai_summaries_enabled',
    label: 'ai-summaries',
    description: 'ai-summaries-feature-description',
    icon: Bot,
    color: 'rgba(20, 184, 166, 0.7)',
    bgColor: 'rgba(20, 184, 166, 0.05)'
  }
];
